var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SelectPointGroupModal"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.smallCodeList,"show-empty":""},on:{"row-clicked":_vm.rowClick}},[[_c('h4',[_vm._v(_vm._s(_vm.$t("데이터가 존재하지 않습니다.")))])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }